var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddcaption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22H18C18.5523 22 19 22.4477 19 23C19 23.5523 18.5523 24 18 24H1C0.447715 24 0 23.5523 0 23C0 22.4477 0.447715 22 1 22ZM1 26C0.447715 26 0 26.4477 0 27C0 27.5523 0.447715 28 1 28H8C8.55229 28 9 27.5523 9 27C9 26.4477 8.55229 26 8 26H1ZM29 6H3C2.44772 6 2 6.44772 2 7V16C2 16.5523 2.44772 17 3 17H29C29.5523 17 30 16.5523 30 16V7C30 6.44772 29.5523 6 29 6ZM3 4C1.34315 4 0 5.34315 0 7V16C0 17.6569 1.34315 19 3 19H29C30.6569 19 32 17.6569 32 16V7C32 5.34315 30.6569 4 29 4H3Z",
    fill: "#838382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcaption);
export default __webpack_public_path__ + "static/media/addcaption.0cdf7b2f.svg";
export { ForwardRef as ReactComponent };var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddcaption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22H18C18.5523 22 19 22.4477 19 23C19 23.5523 18.5523 24 18 24H1C0.447715 24 0 23.5523 0 23C0 22.4477 0.447715 22 1 22ZM1 26C0.447715 26 0 26.4477 0 27C0 27.5523 0.447715 28 1 28H8C8.55229 28 9 27.5523 9 27C9 26.4477 8.55229 26 8 26H1ZM29 6H3C2.44772 6 2 6.44772 2 7V16C2 16.5523 2.44772 17 3 17H29C29.5523 17 30 16.5523 30 16V7C30 6.44772 29.5523 6 29 6ZM3 4C1.34315 4 0 5.34315 0 7V16C0 17.6569 1.34315 19 3 19H29C30.6569 19 32 17.6569 32 16V7C32 5.34315 30.6569 4 29 4H3Z",
    fill: "#838382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcaption);
export default __webpack_public_path__ + "static/media/addcaption.0cdf7b2f.svg";
export { ForwardRef as ReactComponent };